<template>
  <v-layout row wrap mb-4 pa-4>
    <case-header-new></case-header-new>
    <v-layout class="white-bg px-4 py-3 mb-0 elevation-2 rounded-3 documents-container"
      @dragover.prevent="dragOver = true" :class="{ 'drag-over': dragOver }">
      <Loading :isLoading="isLoading">
        <div class="drop-target" @drop.prevent="addFile" @dragleave.prevent="dragOver = false">
          <font-awesome-icon size="lg" icon="upload" @dragleave.prevent></font-awesome-icon>
          <h4 @dragleave.prevent> Drop files to Upload</h4>
          <p>Uploading to {{ breadcrumbs.map(b => b.name).join(" / ") }}</p>
        </div>
        <DocumentsTable :documentHeaders="docsHeader" :files="currentCase.fileAttachments"
          :caseId="parseInt(currentCaseId, 10)" :isCaseMode="true"></DocumentsTable>
      </Loading>

      <!-- Move dialogue controls to separate component? -->
      <v-dialog v-model="moveDialog" max-width="1200">
        <v-card class="pa-4" v-if="moveDialog">
          <v-card-title class="pa-0 pb-4">
            <h2>Moving file: {{ currentFile.name }}</h2>
          </v-card-title>
          <DocumentsTable v-if="moveDialog" :documentHeaders="docsHeader" :isFolderSelectMode="true"></DocumentsTable>

          <v-flex class="pb-0">
            <h2>Move to folder:</h2>
            <v-flex xs class="mt-2 selected-docs">
              <v-flex v-if="currentFolderSelection && currentFolderSelection.path">
                <font-awesome-icon :style="{ color: 'orange' }" size="2x" :icon="['fas', 'folder']"
                  class="mr-3"></font-awesome-icon>
                <h3 class="d-inline-block">selected: <b>{{ currentFolderSelection.path }}</b></h3>
              </v-flex>
              <v-flex v-else>
                <font-awesome-icon :style="{ color: 'orange' }" size="2x" :icon="['fas', 'folder']"
                  class="mr-3"></font-awesome-icon>
                <h3 class="d-inline-block">selected: <b>{{ dialogCurrentFolderPath }}</b></h3>
              </v-flex>
            </v-flex>
          </v-flex>

          <v-card-actions class="ma-0 pa-0 pt-4">
            <v-btn @click="moveFile" color="success">Confirm move</v-btn>
            <v-btn @click="toggleMoveFileDialog(false)" color="secondary">Cancel</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="copyDialog" max-width="1200">
        <v-card class="pa-4" v-if="copyDialog">
          <v-card-title class="pa-0 pb-2">
            <h2>Copying file: {{ currentFile.name }}</h2>
          </v-card-title>
          <DocumentsTable v-if="copyDialog" :documentHeaders="docsHeader" :isFolderSelectMode="true"></DocumentsTable>

          <v-flex class="pb-0">
            <h2>Copy to</h2>
            <v-flex xs class="mt-2 selected-docs">
              <v-flex v-if="currentFolderSelection && currentFolderSelection.path">
                <font-awesome-icon :style="{ color: 'orange' }" size="2x" :icon="['fas', 'folder']"
                  class="mr-3"></font-awesome-icon>
                <h3 class="d-inline-block">selected: <b>{{ currentFolderSelection.path }}</b></h3>
              </v-flex>
              <v-flex v-else>
                <font-awesome-icon :style="{ color: 'orange' }" size="2x" :icon="['fas', 'folder']"
                  class="mr-3"></font-awesome-icon>
                <h3 class="d-inline-block">current folder: <b>{{ dialogCurrentFolderPath }}</b></h3>
              </v-flex>
            </v-flex>
          </v-flex>

          <v-card-actions class="ma-0 pa-0 pt-4">
            <v-btn @click="copyFile()" color="success">Confirm copy</v-btn>
            <v-btn @click="toggleCopyFileDialog(false)" color="secondary">Cancel</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="deleteDialog" max-width="500">
        <v-card class="pa-4" v-if="deleteDialog">
          <v-card-title class="pa-0 pb-0">
            <h2>Delete file: {{ currentFile.name }}</h2>
          </v-card-title>
          <v-card-text class="px-0 pb-3">
            Are you sure you want to delete file "{{ currentFile.name }}"? This cannot be undone.
          </v-card-text>
          <v-card-actions class="ma-0 pa-0 pt-1">
            <v-btn @click="deleteFile()" color="error">Confirm deletion</v-btn>
            <v-btn @click="toggleDeleteFileDialog(false)" color="secondary">Cancel</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="renameDialog" max-width="500">
        <v-card class="pa-4" v-if="renameDialog">
          <v-card-title class="pa-0 pb-2">
            <h2>Rename file: {{ currentFile.name }}</h2>
          </v-card-title>
          <v-card-text class="px-0 pb-0">
            <v-text-field box label="File name" v-model="newFileName" :value="currentFile.name"></v-text-field>
          </v-card-text>
          <v-card-actions class="ma-0 pa-0 pt-1">
            <v-btn @click="renameFile()" color="success">Update name</v-btn>
            <v-btn @click="toggleRenameFileDialog(false)" color="secondary">Cancel</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="duplicateDialog" max-width="500">
        <v-card class="pa-4">
          <v-card-title class="pa-0 pb-2">
            <h2>Rename your duplicate file</h2>
          </v-card-title>
          <v-card-text class="px-0 pb-0">
            <v-text-field box v-model="copyFileName" label="Rename duplicate file"></v-text-field>
          </v-card-text>
          <v-card-actions class="ma-0 pa-0 pt-1">
            <v-btn @click="copyFile(copyFileName, true)" color="success">Duplicate</v-btn>
            <v-btn @click="toggleDuplicateFileDialog(false)" color="secondary">Cancel</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

    </v-layout>
  </v-layout>
</template>

<script>
import Vue from 'vue'
import CaseHeaderNew from "@/components/cases/case-edit/CaseHeaderNew.vue"
import DocumentsTable from "@/components/documents/DocumentsTable.vue"
import Helpers from "@/helpers.js"
import Loading from "@/components/shared/Loading.vue"
import { mapState } from "vuex"

export default {
  name: "case-documents",
  components: { CaseHeaderNew, DocumentsTable, Loading },
  data: () => ({
    newFolderDialog: false,
    renameDialog: false,
    duplicateDialog: false,
    moveDialog: false,
    copyDialog: false,
    deleteDialog: false,
    docsHeader: [
      {
        text: 'Name',
        align: 'left',
        sortable: true,
        value: 'name'
      },
      { text: 'Date added', value: 'date' },
      { text: 'Size', value: 'size' },
      { text: 'Uploaded by', value: 'modified' }
    ],
    newFileName: '',
    copyFileName: '',
    dragOver: false
  }),
  computed: {
    ...mapState({
      user: state => state.currentUser,
      currentCaseId: state => state.cbroute.params.case_id,
      currentCase: state =>
        state && state.cases && state.cases.currentlySelected.case
          ? state.cases.currentlySelected.case
          : {},
      isLoading: state =>
        state && state.cases && state.cases.currentlySelected.case
          ? state.cases.currentlySelected.loading
          : false,
      currentFolderSelection: state => state.folders.currentFolderSelection,
      currentFolderPath: (state) => state.folders.documentsTable.currentFolderPath,
      dialogCurrentFolderPath: (state) => state.folders.dialogDocumentsTable.currentFolderPath,
      currentFile: state => state.folders.currentFile,
      moveFileDialog: state => state.folders.moveFileDialog,
      copyFileDialog: state => state.folders.copyFileDialog,
      deleteFileDialog: state => state.folders.deleteFileDialog,
      duplicateFileDialog: state => state.folders.duplicateFileDialog,
      renameFileDialog: state => state.folders.renameFileDialog,
      breadcrumbs: (state) => state.folders.documentsTable.breadcrumbs,
    }),
    attachments() {
      if (this.currentCase && this.currentCase.fileAttachments) {
        return this.currentCase.fileAttachments
      } else {
        return 1
      }
    }
  },
  methods: {
    addFile(event) {
      if (event.dataTransfer.files) {
        this.$store.dispatch("uploadCaseDocument", { user: this.user, case: this.currentCase, files: event.dataTransfer.files })
      }
      this.dragOver = false
    },
    openBrowser() { this.$refs.attachment.click() },
    onFileSelected(event) {
      this.$store.dispatch("uploadCaseDocument", { user: this.user, case: this.currentCase, files: event.target.files })
    },
    toggleMoveFileDialog(dialogState) {
      this.$store.dispatch('setMoveFileDialog', { dialogState: dialogState, file: null })
    },
    toggleCopyFileDialog(dialogState) {
      this.$store.dispatch('setCopyFileDialog', { dialogState: dialogState, file: null })
    },
    toggleDeleteFileDialog(dialogState) {
      this.$store.dispatch('setDeleteFileDialog', { dialogState: dialogState, file: null })
    },
    toggleRenameFileDialog(dialogState) {
      this.$store.dispatch('setRenameFileDialog', { dialogState: dialogState, file: null })
    },
    toggleDuplicateFileDialog(dialogState) {
      this.$store.dispatch('setDuplicateFileDialog', { dialogState: dialogState, file: null })
    },
    async moveFile() {
      const newFolderLocation = (this.currentFolderSelection && this.currentFolderSelection.path) ? this.currentFolderSelection.path : this.dialogCurrentFolderPath

      if (newFolderLocation) {
        const newFilePath = (newFolderLocation === '/') ? `/${this.currentFile.name}` : `${newFolderLocation}/${this.currentFile.name}`
        if (this.currentFile && this.currentFile.id && this.currentFile.name) {
          await this.$store.dispatch("moveCaseDocument", {
            fileAttachmentId: this.currentFile.id,
            newFilePath,
            newFolderLocation
          })
        } else {
          this.$store.commit("displayFlashMessage", { message: 'Failed to move: Invalid file', severity: "error" })
        }
      } else {
        this.$store.commit("displayFlashMessage", { message: 'Failed to move: Invalid folder location', severity: "error" })
      }
    },
    async copyFile(newName = false, isDuplicate = false) {
      let newFolderLocation = this.currentFolderPath
      if (!isDuplicate) {
        if (this.currentFolderSelection && this.currentFolderSelection.path) {
          newFolderLocation = this.currentFolderSelection.path
        } else {
          newFolderLocation = this.dialogCurrentFolderPath
        }
      }
      const newFileName = newName || this.currentFile.name

      if (newFolderLocation) {
        const newFilePath = (newFolderLocation === '/') ? `/${newFileName}` : `${newFolderLocation}/${newFileName}`
        if (this.currentFile && this.currentFile.id && newFileName) {
          const result = await this.$store.dispatch("copyCaseDocument", {
            fileAttachmentId: this.currentFile.id,
            newFilePath,
            newFolderLocation
          })
          if (result) this.copyFileName = ''
        } else {
          this.$store.commit("displayFlashMessage", { message: 'Failed to copy: Invalid file', severity: "error" })
        }
      } else {
        this.$store.commit("displayFlashMessage", { message: 'Failed to copy: Invalid folder location', severity: "error" })
      }
    },
    async deleteFile() {
      if (this.currentFile && this.currentFile.id) {
        await this.$store.dispatch("deleteCaseDocument", { fileAttachmentId: this.currentFile.id })
      } else {
        this.$store.commit("displayFlashMessage", { message: 'Failed to delete: no file selected', severity: "error" })
      }
    },
    async renameFile() {
      if (Helpers.isValidFolderOrFileName(this.newFileName)) {
        if (this.currentFolderPath) {
          const newFilePath = (this.currentFolderPath === '/') ? `/${this.newFileName}` : `${this.currentFolderPath}/${this.newFileName}`
          if (this.currentFile && this.currentFile.id) {
            const result = await this.$store.dispatch("moveCaseDocument", {
              fileAttachmentId: this.currentFile.id,
              newFilePath,
              isFileRename: true
            })
            if (result) this.newFileName = ''
          } else {
            this.$store.commit("displayFlashMessage", { message: 'Failed to rename: Invalid file', severity: "error" })
          }
        } else {
          this.$store.commit("displayFlashMessage", { message: 'Failed to rename: invalid location or file name', severity: "error" })
        }
      } else {
        this.$store.commit("displayFlashMessage", { message: 'Failed to rename: cannot be empty, contain slashes or start with a peroid', severity: "error" })
      }
    }
  },
  beforeRouteLeave(to, from, next) {
    const state = Vue.store.state
    const currentUser = Object.assign(state.currentUser.me, { account: { id: state.currentUser.account.id } })
    Vue.store.dispatch("unsubscribeToCaseChannelV2", { caseId: from.params.case_id, currentUser: currentUser })
    next()
  },
  beforeRouteEnter(to, from, next) {
    const state = Vue.store.state
    const currentUser = Object.assign(state.currentUser.me, { account: { id: state.currentUser.account.id } })
    Vue.store.dispatch("subscribeToCaseChannelV2", { caseId: to.params.case_id, currentUser })
    next()
  },
  watch: {
    moveFileDialog(newVal) {
      this.moveDialog = newVal
    },
    copyFileDialog(newVal) {
      this.copyDialog = newVal
    },
    deleteFileDialog(newVal) {
      this.deleteDialog = newVal
    },
    duplicateFileDialog(newVal) {
      this.duplicateDialog = newVal
    },
    renameFileDialog(newVal) {
      this.renameDialog = newVal
    },
    moveDialog(newVal) {
      if (newVal !== this.moveFileDialog) {
        this.$store.dispatch('setMoveFileDialog', { dialogState: newVal, file: null })
      }
    },
    copyDialog(newVal) {
      if (newVal !== this.copyFileDialog) {
        this.$store.dispatch('setCopyFileDialog', { dialogState: newVal, file: null })
      }
    },
    deleteDialog(newVal) {
      if (newVal !== this.deleteFileDialog) {
        this.$store.dispatch('setDeleteFileDialog', { dialogState: newVal, file: null })
      }
    },
    renameDialog(newVal) {
      if (newVal !== this.renameFileDialog) {
        this.$store.dispatch('setRenameFileDialog', { dialogState: newVal, file: null })
      }
    },
    duplicateDialog(newVal) {
      if (newVal !== this.duplicateDialog) {
        this.$store.dispatch('setDuplicateFileDialog', { dialogState: newVal, file: null })
      }
    }
  }
}
</script>

<style lang="scss">
.documents-container {
  position: relative;

  .drop-target {
    display: none;
  }

  &.drag-over {
    .drop-target {
      position: absolute;
      top: 0;
      left: 0;
      background-color: #000000a1;
      height: 100%;
      width: 100%;
      border: 1px solid black;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      padding: 50px;
      color: white;
      font-size: 1.8em;

      z-index: 100;

      h4 {
        font-size: 1.5em;
      }

      * {
        pointer-events: none;
      }
    }
  }
}

.documents-container.drag-over .drop-target {}
</style>

<style stylus>
.doc-table .doc-primary-td {
  padding: 0 12px !important;
  width: 45%;
  position: relative;
}

.doc-table .doc-primary-td svg {
  position: absolute;
  left: 12px;
  top: 10px;
}

.doc-table .doc-primary-td .v-menu {
  position: absolute;
  right: 0px;
  top: 14px;
  opacity: 0;
  transition: all 0.3s;
}

.doc-table tr:hover>.doc-primary-td .v-menu {
  opacity: 1;
}

.doc-table .doc-primary-td h3 {
  padding: 0 40px;
}

.doc-table .doc-primary-td h3 a {
  text-decoration: none;
}

.doc-table .doc-primary-td h3 a:hover {
  text-decoration: underline;
}

.doc-table table.v-table thead th:first-child {
  padding: 0 12px !important;
}
</style>